import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import classnames from 'classnames';
import styles from './styles.module.scss';

interface FiltersBarProps {
  filters?: React.ReactNode;
  buttons?: React.ReactNode;
  containerClassnames?: string;
}

const FiltersBar = ({filters, buttons, containerClassnames}: FiltersBarProps) => {
  const [show, setShow] = useState(window.innerWidth >= 990);

  return (
    <div className={classnames(styles.filtersBar, containerClassnames)}>
      <div className={styles.buttons}>
        {buttons}
        {filters && (
          <Button
            onClick={() => setShow(!show)}
            className={classnames(styles.showHideFiltersButton, 'btn btn-sm p-0', show ? styles.hideFiltersButton : styles.showFiltersButton)}
          >
            <img
              src={toAbsoluteUrl(`/media/svg/${show ? 'Show_brandColor.svg' : 'Show_white.svg'}`)}
              height={24} alt="icon"
            />
          </Button>
        )}
      </div>
      {filters && (
        <form className={styles.filters}>
          {show ? filters : null}
        </form>
      )}
    </div>
  );
};

export default FiltersBar;
